import React from 'react';
import cx from 'classnames';
import NextButtonIcon from './NextButtonIcon';

/**
 * NextButton — the designed "next" button (TT-1139) shared by the no-cursor and
 * tap-to-read experiences, both in live reading and in the TutorFTUE demos.
 *
 * Renders a teal chevron pill (.phraseNextButton in Reader.scss) whose glyph is an
 * SVG chevron (NextButtonIcon) — no typography. This is deliberately NOT the shared
 * Global <Button type="next"> used by NextPageButton for page navigation, so page-turn
 * buttons are unaffected. `type="button"` keeps it from ever implicitly submitting a form.
 *
 * `className` appends modifier classes (e.g. "showNextButton" for the cursor-free reveal).
 */
export default function NextButton({ onClick, className, ariaLabel = 'Continue to next phrase' }) {
  return (
    <button
      type="button"
      className={cx('phraseNextButton', className)}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <NextButtonIcon />
    </button>
  );
}
